import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { insightsArticles } from "@/components/equinox/data";

export default function InsightsPage() {
  return (
    <section className="px-6 pb-20 pt-16 sm:px-8 lg:px-12 lg:pb-28 lg:pt-20">
      <div className="mx-auto max-w-7xl">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="max-w-3xl">
          <p className="section-kicker">Insights</p>
          <h1 className="section-heading mt-5 max-w-[13ch] text-white">Sharp thinking for apps that want lower CAC and cleaner scale.</h1>
          <p className="section-copy mt-6 text-white/[0.64]">
            A clean editorial layer for operators who care about acquisition systems, conversion quality, and growth execution.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {insightsArticles.map((article, index) => (
            <motion.article
              key={article.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.55, delay: index * 0.05 }}
              className={`editorial-shell glitter-card glass-panel cinematic-card rounded-[1.9rem] p-6 ${index === 0 ? "xl:col-span-2" : ""}`}
              data-testid={`insight-card-${index + 1}`}
            >
              <p className="text-xs uppercase tracking-[0.24em] text-blue-100">{article.category}</p>
              <h2 className="mt-4 font-display text-2xl text-white">{article.title}</h2>
              <p className="mt-4 text-sm leading-8 text-white/[0.66]">{article.excerpt}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-sm text-white/80">
                Read insight
                <ArrowRight className="h-4 w-4 text-blue-200" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}